<template>
  <div>
    <div v-for="section in sections" :key="section.value.title">
      <div class="t-xl gray bold m-tx3">{{ section.value.title }}</div>
      <div v-for="category in section.value.categories" :key="category.machine_name">
        <div v-if="category.text" v-emoji="category.text" class="t-lg f-ac bold m-tx3" />
        <div v-for="field in category.fields" :key="field.machine_name">
          <div class="f-h f-sb m-tx2">
            <div class="w-50p t m-rx3">{{ field.text }}</div>
            <div v-if="field.id" class="m-lx3 w-50p">
              <donut-form-input
                :for="field.value.value"
                :name="`field_${field.id}`"
                :validators="field.validators"
              >
                <donut-input-text
                  v-model="field.value.value"
                  :textarea="true"
                  :autogrow="true"
                  :placeholder="field.placeholder"
                  :disabled="formSubmitted"
                  :full-height-text-area="false"
                  :wysiwyg="false"
                />
              </donut-form-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import useValidators from 'composables/validators';

const props = defineProps({
  profileEntries: {
    type: Array,
    required: true,
  },
  formSubmitted: {
    type: Boolean,
    default: false,
  },
});

const { characterCountValidator } = useValidators();

const CAREER_CATEGORIES = ['experience', 'growth'];
const INTERESTS_CATEGORIES = ['personal_history', 'activity', 'food', 'arts_and_entertainment'];

const createSection = (categoryNames, title) => computed(() => ({
  title,
  categories: categoryNames.map(categoryName => {
    const entryCategory = props.profileEntries.find(e => e.category?.machine_name === categoryName);
    if (!entryCategory) return null;
    return {
      ...entryCategory.category,
      fields: entryCategory.entries
        .map(entry => ({
          ...entry.field,
          value: ref(entry.text ?? ''),
          placeholder: 'Type your answer',
          validators: [characterCountValidator(2500, 'This field')],
        }))
        .sort((a, b) => (a.ordinal ?? 0) - (b.ordinal ?? 0)),
    };
  }).filter(Boolean).sort((a, b) => (a.ordinal ?? 0) - (b.ordinal ?? 0)),
}));

const careerSection = createSection(CAREER_CATEGORIES, 'CAREER');
const interestsSection = createSection(INTERESTS_CATEGORIES, 'INTERESTS');

const sections = computed(() => [careerSection, interestsSection]);

defineExpose({
  sections,
});
</script>
